import { IMAGE_BASE_PATH } from "./config";

export const USER_TYPES = {
  CUSTOMER: "customer",
  AGENT: "agent",
  COPS: "cops",
  UW: "uw",
  TELEUW: "teleuw",
  RETENTION: "retention",
  OPS: "ops",
  SUPER: "super",
};
export const PRODUCER_TYPE = {
  POSP: "POSP",
  INTERNAL_POSP: "INTERNAL POSP",
};

export const CALL_TYPES = {
  CALL_NOW: "Call Now",
  CALL_LATER: "Call Later",
};

export const LANGUAGES = [
  {
    id: "1",
    label: "Hindi",
    value: "Hindi",
  },
  {
    id: "2",
    label: "Marathi",
    value: "Marathi",
  },
  {
    id: "3",
    label: "English",
    value: "English",
  },
  {
    id: "4",
    label: "Gujarati",
    value: "Gujarati",
  },
  {
    id: "5",
    label: "Telugu",
    value: "Telugu",
  },
  {
    id: "6",
    label: "Bengali",
    value: "Bengali",
  },
  {
    id: "7",
    label: "Bhojpuri",
    value: "Bhojpuri",
  },
  {
    id: "8",
    label: "Sindhi",
    value: "Sindhi",
  },
  {
    id: "9",
    label: "Konkani",
    value: "Konkani",
  },
  {
    id: "10",
    label: "Punjabi",
    value: "Punjabi",
  },
  {
    id: "11",
    label: "Malayalam",
    value: "Malayalam",
  },
  {
    id: "12",
    label: "Tamil",
    value: "Tamil",
  },
  {
    id: "13",
    label: "Kannada",
    value: "Kannada",
  },
  {
    id: "14",
    label: "Marwari",
    value: "Marwari",
  },
];
export const EXCLUDED_TELEMER_LANGUAGES = [
  "Sindhi",
  "Konkani",
  "Punjabi",
  "Bhojpuri",
  "Marwari",
];
export const TIME_SLOTS = [
  {
    id: "1",
    label: "09:00 AM-09:30 AM",
    value: "09:00 AM-09:30 AM",
  },
  {
    id: "2",
    label: "09:30 AM-10:00 AM",
    value: "09:30 AM-10:00 AM",
  },
  {
    id: "3",
    label: "10:00 AM-10:30 AM",
    value: "10:00 AM-10:30 AM",
  },
  {
    id: "4",
    label: "10:30 AM-11:00 AM",
    value: "10:30 AM-11:00 AM",
  },
  {
    id: "5",
    label: "11:00 AM-11:30 AM",
    value: "11:00 AM-11:30 AM",
  },
  {
    id: "6",
    label: "11:30 AM-12:00 PM",
    value: "11:30 AM-12:00 PM",
  },
  {
    id: "7",
    label: "12:00 PM-12:30 PM",
    value: "12:00 PM-12:30 PM",
  },
  {
    id: "8",
    label: "12:30 PM-01:00 PM",
    value: "12:30 PM-01:00 PM",
  },
  {
    id: "9",
    label: "01:00 PM-01:30 PM",
    value: "01:00 PM-01:30 PM",
  },
  {
    id: "10",
    label: "01:30 PM-02:00 PM",
    value: "01:30 PM-02:00 PM",
  },
  {
    id: "11",
    label: "02:00 PM-02:30 PM",
    value: "02:00 PM-02:30 PM",
  },
  {
    id: "12",
    label: "02:30 PM-03:00 PM",
    value: "02:30 PM-03:00 PM",
  },
  {
    id: "13",
    label: "03:00 PM-03:30 PM",
    value: "03:00 PM-03:30 PM",
  },
  {
    id: "14",
    label: "03:30 PM-04:00 PM",
    value: "03:30 PM-04:00 PM",
  },
  {
    id: "15",
    label: "04:00 PM-04:30 PM",
    value: "04:00 PM-04:30 PM",
  },
  {
    id: "16",
    label: "04:30 PM-05:00 PM",
    value: "04:30 PM-05:00 PM",
  },
  {
    id: "17",
    label: "05:00 PM-05:30 PM",
    value: "05:00 PM-05:30 PM",
  },
  {
    id: "18",
    label: "05:30 PM-06:00 PM",
    value: "05:30 PM-06:00 PM",
  },
];
export const ACTION = {
  VIEW: "view",
  EDIT: "edit",
};

// Zone hierarchy: Zone C (lowest) < Zone B < Zone A (highest)
export const ZONES = {
  ZONE_A: "Zone A",
  ZONE_B: "Zone B",
  ZONE_C: "Zone C",
};

export const ZONE_HIERARCHY = {
  "Zone C": 1,
  "Zone B": 2,
  "Zone A": 3,
};

export const APP_NAMES = {
  IPDS: "IPDS",
  CRM: "CRM",
  PACE: "PACE",
  SUPERAPP: "superapp",
};

export const PRODUCT_NAME_UIN_MAP = {
  "Criti-Medicare": "TATHLIP22176V012122",
  MediCare: "TATHLIP23118V032223",
};

export const SCHEME_TYPE = {
  As_Is: "As Is",
  Higher_SI_Slab: "Higher SI Slab 1",
};

export const INCORRECT_OTP_ATTEMPTS = {
  "you have 1 more attempts left": "1",
  "you have 2 more attempts left": "2",
  "you have 3 more attempts left": "3",
  "you have 4 more attempts left": "4",
};

export const LOB = {
  MOTOR: "motor",
  HEALTH: "health",
  TRAVEL: "travel",
  PA: "pa",
};

export const INTENTS = {
  BUY_POLICY: "BUY_POLICY",
  REVIEW_POLICY: "REVIEW_POLICY",
  COL_POLICY: "COL_POLICY",
  PROPOSAL_POLICY: "PROPOSAL_POLICY",
  PENDING_DOCS_POLICY: "PENDING_DOCS_POLICY",
  TELEMER: "telemer",
  PROPOSAL: "proposal",
  RENEWAL: "RENEWAL",
  ENDORSEMENT: "ENDORSEMENT",
  REBOOK: "REBOOK_POLICY",
};

export const HTTP_STATUS_CODES = {
  BAD_REQUEST: "400",
  UNAUTHORIZED: 401,
  FORBIDDEN: "403",
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: "500",
  OK: 200,
  CREATED: 201,
  TIMEOUT: 504,
};

export const POLICY_STATUS = {
  PENDING: "PENDING",
  PAYMENT_PENDING: "PAYMENT PENDING",
  POLICY_ISSUANCE_PENDING: "ISSUANCE PENDING",
  POLICY_ISSUANCE_RETRY: "ISSUANCE RETRY",
  POLICY_ISSUED: "POLICY ISSUED",
  POLICY_ISSUANCE_FAILED: "ISSUANCE FAILED",
};

export const PAYMENT_STATUS = {
  SUCCESS: "Success",
  FAILED: "Failed",
  PENDING: "Pending",
};

export const PUBLIC_PATHS = [
  "/",
  "/redirection",
  "/info",
  "/congratulation",
  "/rejected",
];

export const RESOURCE_ROUTE_MAP = {
  RENEWAL_HEALTH: ["/quote", "/proposal"],
};

export const MESSAGES = {
  DEFAULT_MESSAGE: "Something went wrong. Please try again later.",
  DEFAULT_ERROR: "Something went wrong! ",
  NO_DATA_FOUND: "No data found!",
  NO_DATA_TO_DISPLAY: "No data to display!",
  TIMEOUT_MESSAGE:
    "We are processing your request. Please check in a few minutes.",
  ERROR_TIMEOUT_MESSAGE:
    "Your Request has timeout, Please try again after sometime!",
  TOKEN_EXPIRE_MESSAGE:
    "Your session has timed out due to inactivity. Please log in again to continue.",
  ACCESS_RESTRICTED:
    "Thanks for visiting Bolt . We are getting ready for the launch. Please check back in a few days.",
  PROPOSAL_EXPIRY:
    "This proposal has expired. Please clone to proceed or create a new proposal",
  AGENT_AGE_BAND_CHANGE:
    "The premium value is changed because of the age band changes. Please share the updated consent link to Send a fresh consent",
  AGE_BAND_EXCEED: "Unable to proceed due to age band changes",
  CUSTOMER_AGE_BAND_CHANGE:
    "The premium value is changed because of the age band changes. Please click okay to acknowledge the same.",
  SUITABLE_TIME:
    "You will receive a call for Telemedical Examination, Kindly tell us your suitable time",
  OCR_FAILED:
    "Failed to fetch the details from OCR API,Please fill the details manually",
  SUM_INSURED_GREATER_THEN_SELF:
    "Sum insured of other members cannot be greater than self.",
  DEDUCTIBLE_GREATER_THEN_SELF:
    "Deductible of other members should not be less than self",
  SUM_INSURED_GREATER_THEN_HIGHEST_AGE:
    "Sum insured of other members cannot be greater than the member with highest age.",
  DEDUCTIBLE_LESS_THEN_HIGHEST_AGE:
    "Deductible of other members should not be less than the member with highest age.",
  INVALID_DEDUCTIBLE_FOR_SUM_INSURED:
    "Selected deductible is not valid for the chosen sum insured. Please select a valid deductible.",
  DOCUMENT_NOT_FOUND:
    "The document is getting generated. Please try after some time from the Order tracking.",
  EXISTING_CUSTOMER_NOT_FOUND:
    "The customer details you have entered does not match the details which were used to create the customer.",
  PREMIER_PLAN: "Sum insured selected should be of same plan",
  PREMIUM_REVISE_MEDICAL:
    "Premiums revised based on member added for medical details",
  TRANSICARE_GMC:
    "Due to non-availability of GMC policy with proposer, transicare add-on cannot be opted",
};

export const MESSAGE_TYPES = {
  INFO: "info",
  ERROR: "error",
  SUCCESS: "success",
};

export const OTP_MESSAGES = {
  VERIFIED: "OTP Verification successful.",
  EXPIRED: "OTP has expired",
  EXHAUSTED: "You have exhausted the permissible number of retries",
  RESEND_TIME: 120,
  TOTAL_ATTEMPTS: 5,
};

export const PLAN_TYPES = {
  FLOATER: "Floater",
  INDIVIDUAL: "Individual",
};

export const RELATIONSHIP_MAP = [
  ["Self", "Spouse"],
  ["Father", "Mother"],
  ["Father In Law", "Mother In Law"],
  ["Grand Father", "Grand Mother"],
];

export const RELATIONSHIP = [
  // REMOVE THIS
  { id: 1, label: "Spouse", value: "Spouse" },
  { id: 2, label: "Mother", value: "Mother" },
  { id: 3, label: "Father", value: "Father" },
  { id: 4, label: "Son", value: "Son" },
  { id: 5, label: "Daughter", value: "Daughter" },
  { id: 6, label: "Sister", value: "Sister" },
];

export const DECLARATION_TEXT = {
  WARRANTY_DECLARATION: [
    {
      id: 1,
      data: "I hereby declare, on my behalf and on behalf of call person proposed to be insured, that the above statements answers and/or particulars given by me are true and complete in all respects to the best of my knowledge and that I am authorized to propose on behalf of these other persons.",
    },

    {
      id: 2,
      data: "I understand that the information provided by me will form the basis of the insurance policy, is subject to the Board approved underwriting policy of the insurer and that the policy will come into force only after full payment of the premium chargeable.",
    },
    {
      id: 3,
      data: "I declared that I consent to the company seeking medical information from any doctor or hospital who/which at any time attended on the person to be insured/proposer or from any past or present employer concerning any thing which effects the physical or mental health of the person to be insured/proposer and seeking information from any insurer to whom an application for insurance on the person to be insured/proposer has been made for the purpose of underwriting the proposal and/or claim settlement.",
    },
    {
      id: 4,
      data: "I authorize the company to share information pertaining to  my proposal including the medical records of the insured/porposer for the sole purpose of underwriting the proposal and/or claims settlement and with any Governmental and/or Regulatory authority.",
    },
  ],
  AGENT_DECLARATION:
    "in my capacity as an Insurance Advisor/ Specified Person of the Corporate Agent/Authorized employee of the Broker/Relationship Officer, do hereby declare that I have explained all the contents of this Proposal Form, including the nature of the questions contained in this Proposal Form to the Proposer including statement(s), information and response(s) submitted by him/her in this Proposal Form to questions contained herein or any details sought herein will form the basis of the Contract of Insurance between the Company and the Proposer, if this Proposal is accepted by the Company for issuance of the Policy. I have further explained that if any untrue statement(s)/ information/response(s) is/are contained in this Proposal Form/including addendum(s), affidavits, statements, submissions, furnished/to be furnished, the Company shall have the right to vary the benefits which may be payable and further more if there has been a non-disclosure of any material fact, the policy issued to his/her favour pursuant to this Proposal may be treated by the Company as null and void and all premiums paid under the Policy may be forfeited to the company.",
  MEDICAL_DECLARATION:
    "We believe that all the medical conditions such as Diabetes mellitus , Hypertension etc. have been declared completely and correctly in the relevant sections on this page. Please remember that in event of a claim wherein there is identification of any non-disclosure of information , the insurer reserves the rights to repudiate the claim and cancel the policy.",
  CONSENT_DATA: " / confirming OTP, I, {{PROPOSER_NAME}}, hereby declare, ",
  CONSENT_DATA_2:
    "on my behalf and on behalf of all persons proposed to be insured,confirm, and agree to the following for my ",
  CONSENT_DATA_3:
    " health insurance proposal with TATA AIG General Insurance Company Limited:",
  CONSENT_DATA_PA_1:
    "Personal Accident Insurance proposal with TATA AIG General Insurance Company Limited.",
  POLITICALLY_EXPOSED_PERSON:
    "I / We are Politically Exposed Persons / close relatives / family members / associates of Politically Exposed Persons. I / We shall keep the company informed in case of change in the status of not coming under a Politically Exposed Person / close relative / family member / associates of Politically Exposed Persons. “Politically Exposed Persons” shall have the meaning assigned to it under Prevention of Money-Laundering (Maintenance of Records) Amendment Rules, 2023 as amended from time to time.",
  AGENT_DECLARATION_PA:
    "in my capacity as an Insurance Advisor/Specified Person of the Corporate Agent/Authorised employee of the Broker/Relationship Officer, do hereby declare that I have explained all the contents of this Proposal Form, including the nature of the questions contained in this Proposal Form to the Proposer including statement(s), information and response(s) submitted by him/her in this Proposal Form to questions contained herein or any details sought herein will form the basis of the Contract of Insurance between the Company and the Proposer, if this Proposal is accepted by the Company for issuance of the Policy. I have further explained that if any untrue statement(s)/information/response(s) is/are contained in this Proposal Form including Addendum(s), A davits, statements, submissions, furnished/to be furnished, the Company shall have the right to vary the benefits which may be payable and further more if there has been a non-disclosure of any material fact, the Policy Issued to his/her favour pursuant to this Proposal may be treated by the Company as null and void and all premiums paid under the Policy may be forfeited to the Company.",
  WARRANTY_DECLARATION_PA: [
    {
      id: 1,
      data: "I hereby declare, on my behalf and on behalf of all persons proposed to be Insured, that the above statements, answers and/or particulars given by me are true and complete in all respect to the best of my knowledge and that I am authorised to propose on behalf of these other persons.",
    },
    {
      id: 2,
      data: "I hereby confirm that I have truthfully and completely declared in this Proposal, all the Personal Accident Policies under which myself or any other member proposed for Insurance are currently Insured with either TATA AIG General Insurance co. Ltd. or any other Insurance Company. I also hereby confirm that irrespective of the number of Policies an Insured member is covered under, the maximum liability of TATA AIG General Insurance co. Ltd. in aggregate per member shall be restricted to either of the actual annual income of the Insured Person as declared for the year of the accidental loss; or admissible claim amount as per the applicable Sum Insured plus any accrued cumulative bonus as per the terms of the relevant Policy; or the maximum Sum Insured o ered by the Product, whichever is lower.",
    },
    {
      id: 3,
      data: "I understand that the information provided by me will form the basis of the Insurance Policy, is subject to the Board approved underwriting Policy of the Insurer and that the Policy will come into force only after full payment of the premium chargeable.",
    },
    {
      id: 4,
      data: "I further declare that I will notify in writing any change occurring in the occupation or general health of the life to be Insured/Proposer after the Proposal has been submitted but before communication of the risk acceptance by the Company.",
    },
    {
      id: 5,
      data: "I declare that I consent to the Company seeking medical information from any doctor or hospital who/which at any time has attended on the persons proposed to be Insured/Proposer or from any past or present employer concerning anything which affects the physical or mental health of the persons proposed to the Insured/Proposer and seeking information from any Insurer to whom an application for Insurance on the persons proposed to be Insured/Proposer has been made for the purpose of underwriting the Proposal and/or claim settlement.",
    },
    {
      id: 6,
      data: "I authorise the Company to share information pertaining to my Proposal including the medical records of the persons proposed to be Insured/Proposer for the sole purpose of underwriting the Proposal and/or claims settlement and with any Governmental and/or Regulatory authority. I have understood the purpose of Aadhar authentication and hereby state that I have no objection in providing my Aadhar details.",
    },
    {
      id: 7,
      data: "I hereby confirm that I have truthfully and completely declared in this Proposal, all other Insurance Policies under which myself or any other member have proposed for Insurance or are currently Insured with either TATA AIG General Insurance co ltd or any other Insurance Company. I hereby declare that I have correctly mentioned my occupation and the income declared is as appearing in form 16 / Salary Slip / ITR acknowledgement.",
    },
    {
      id: 8,
      data: "I also hereby confirm that irrespective of the number of Policies an Insured Member is covered under, the maximum liability of TATA AIG General Insurance Co. Ltd. in aggregate per member shall be restricted to the minimum of: 25 times the annual income of the Insured person for the year of the accidental loss; or Admissible claim amount as per the applicable Sum Insured plus any accrued Cumulative Bonus as per the terms of the Relevant Policy; or ₹ 5 Crores.",
    },
    {
      id: 9,
      data: "In case of Temporary Total Disability, the maximum liability of TATA AIG General Insurance co. ltd. in aggregate per Insured Person shall be restricted to highest weekly bene t amount under any one Policy based on Insured Person’s income eligibility.",
    },
  ],
};

export const PENDING_ORDER_STATUS = [
  { id: 1, label: "All", value: "All" },
  {
    id: 2,
    label: "Requirement",
    value: "Requirement",
  },
  {
    id: 3,
    label: "Refer To PPC",
    value: "ReferToPPC",
  },
  {
    id: 4,
    label: "KYC",
    value: "KycPending",
  },
  {
    id: 5,
    label: "Payment Pending",
    value: "PaymentPending",
  },
  {
    id: 6,
    label: "Additional Info Required",
    value: "AdditionalInfoRequired",
  },

  {
    id: 7,
    label: "Counter Offer Letter",
    value: "CounterOfferInitiated",
  },

  {
    id: 8,
    label: "NSTP",
    value: "NSTP",
  },
  {
    id: 9,
    label: "Customer Consent Pending",
    value: "CustomerConsentPending",
  },
];

export const COMPLETED_ORDER_STATUS = [
  {
    id: 1,
    label: "All",
    value: "All",
  },
  {
    id: 2,
    label: "Policy Issued",
    value: "PolicyIssued",
  },
  {
    id: 3,
    label: "Rejected",
    value: "Reject",
  },
  {
    id: 4,
    label: "Cancelled",
    value: "Cancelled",
  },
];

export const DATE_TRACKING = [
  {
    id: "0",
    label: "All",
    value: "All",
  },
  {
    id: "1",
    label: "1 week",
    value: "1 week",
  },
  {
    id: "2",
    label: "Last 21 Days",
    value: "Last 21 Days",
  },
  {
    id: "3",
    label: "Last 1 Month",
    value: "Last 1 Month",
  },
];

export const SORT_OPTION = [
  {
    id: "1",
    label: "Ascending",
    value: "Ascending",
  },
  {
    id: "2",
    label: "Descending",
    value: "Descending",
  },
];

export const DATES_FILTER = {
  ALL: "All",
  WEEK_1: "1 week",
  LAST_21_DAYS: "Last 21 Days",
  LAST_1_MONTH: "Last 1 Month",
};
export const FIELD_ARRAY_QUESTIONS = ["q2", "q3", "q4", "q5", "q9", "q11"];
export const MEDICAL_QUESTIONS = {
  Q1: "Have you or any of the persons proposed for insurance, ever suffered from or taken treatment, or hospitalized for or have been recommended to take investigations / medication / surgery or undergone a surgery for the following medical conditions?",
  Q2: "Any other illness/disease/injury/disability in the past other than for childbirth, flu or for minor injuries that have completely healed?",
  Q3: "Are you or any persons proposed on regular medication (including any Ayurvedic treatment) or Hospitalized for any illness/ surgery or awaiting any procedure/treatment?",
  Q4: "Have you ever been diagnosed with any of these medical conditions with or without any follow-up tests/medications? – Elevated Blood Sugar/ Type 2 Diabetes Mellitus/ Elevated Blood Pressure/ Hypertension/High Cholesterol/ Asthma",
  Q5: "Is any of the insured pregnant currently? If yes, please mention expected date of delivery (EDD). Any history of pregnancy related complications?",
  Q6: "Has any application for life, Health or critical illness insurance ever been declined, postponed, loaded or been made subject to any special conditions by any insurance company?",
  Q7: "Has any health or life insurance policy ever been terminated in the past?",
  Q8: "Have you ever been diagnosed with any Thyroid Disorder with or without any follow-up tests/medications?",
  Q9: "Do you have any signs, symptoms, illness or injury including knee joint ligament tear or back pain/ Swelling or Pain in any part of body / Breathlessness on mild effort / dizziness more than once in last 6 months for which medical consultation / treatment / investigation has been required?",
  Q10: "Have you undergone any annual health check-up or routine medical examination in the past year? (If yes, please provide details of any findings or results)",
};
export const MEDICAL_QUESTIONS_PA = {
  Q1: "History of illness/disease/injury/disability in the past other than for childbirth, flu or for minor injuries that have completely healed?",
  Q2: "Has any of the Person’s proposed for insurance application or reinstatement application on life, accident,medical or health, critical illness, or disability ever been declined, postponed or accepted at extra premium or modified terms.",
};

export const RELATIONSHIP_MASTER = {
  Self: "Self",
  Spouse: "Spouse",
  "Son 1": "Son 1",
  "Son 2": "Son 2",
  "Son 3": "Son 3",
  "Son 4": "Son 4",
  "Son 5": "Son 5",
  "Daughter 1": "Daughter 1",
  "Daughter 2": "Daughter 2",
  "Daughter 3": "Daughter 3",
  "Daughter 4": "Daughter 4",
  "Daughter 5": "Daughter 5",
  Father: "Father",
  Mother: "Mother",
  "Father In Law": "Father-In Law",
  "Mother In Law": "Mother-In Law",
  "Grand Father": "Grand Father",
  "Grand Mother": "Grand Mother",
};

export const QUICK_ACTIONS_IMGS = {
  0: `${IMAGE_BASE_PATH}/images/quick-link/kyc.svg`,
  1: `${IMAGE_BASE_PATH}/images/quick-link/col.svg`,
  2: `${IMAGE_BASE_PATH}/images/quick-link/paymentPending.svg`,
  3: `${IMAGE_BASE_PATH}/images/quick-link/infoRequired.svg`,
};

export const PAYMENT_SUMMARY = {
  PAYMENT_SUCCESS: {
    heading: "Congratulations",
    info: "Congratulations your policy has been issued!",
    image: `${IMAGE_BASE_PATH}/images/payment-success.svg`,
    renewalInfo: "Congratulations your policy has been renewed!",
    endorsementInfo: "Congratulations your policy has been endorsed!",
    color: "aigColor35",
  },
  PAYMENT_DECLINE: {
    heading: "Payment Declined",
    info: "Payment was declined",
    image: `${IMAGE_BASE_PATH}/images/payment-decline.svg`,
    color: "aigColor53",
  },
  PAYMENT_PARTIAL: {
    heading: "Payment Received",
    info: "Partial payment received",
    image: `${IMAGE_BASE_PATH}/images/payment-partial.svg`,
    color: "aigColor52",
  },
  PAYMENT_RECIEVED: {
    heading: "Payment Received",
    info: "Your proposal will be reviewed",
    image: `${IMAGE_BASE_PATH}/images/payment-recieved.svg`,
    color: "aigColor51",
  },
  PAYMENT_PENDING: {
    heading: "Your payment is under pending state",
    info: "We are verifying payment details paid by you",
    image: `${IMAGE_BASE_PATH}/images/payment-partial.svg`,
    color: "aigColor52",
  },
  OTM_PAYMENT_BLOCK: {
    heading: "Your payment amount is blocked",
    info: "Proposal has been moved for further processing",
    image: `${IMAGE_BASE_PATH}/images/payment-partial.svg`,
    color: "aigColor52",
  },
  OTM_POLICY_ACCEPTED: {
    heading: "Your proposal has been accepted.",
    info: "Policy will be issued soon",
    image: `${IMAGE_BASE_PATH}/images/payment-partial.svg`,
    color: "aigColor52",
  },
  PAYMENT_DOWNLOAD: {
    image: `${IMAGE_BASE_PATH}/images/download-icon.svg`,
  },
  DECISION_IN_PROGRESS: {
    heading: "Your proposal is under review",
    info: "Your proposal is under processing",
    image: `${IMAGE_BASE_PATH}/images/payment-partial.svg`,
    color: "aigColor52",
  },
};

export const COPS_ACTIONS = {
  ACCEPT: "Accept",
  REJECT: "Reject",
  DISCREPANCY: "Discrepancy",
};
export const UW_ACTIONS = {
  ACCEPT: "Accept",
  REJECT: "Reject",
  ACCEPT_WITH_EXCLUSION: "AcceptWithExclusion",
  ACCEPT_WITH_LOADING: "AcceptWithLoading",
  ACCEPT_WITH_LOADING_EXCLUSION: "AcceptWithExclusionAndLoading",
  ADDITIONAL_INFO_REQUIRED: "AdditionalInfoRequired",
  ACCEPT_WITH_TELEMER: "AcceptWithTeleMER",
  ACCEPT_WITH_PPC: "AcceptWithPPC",
};
export const UW_ACTIONS_PA = {
  ACCEPT: "Accept",
  REJECT: "Reject",
  ADDITIONAL_INFO_REQUIRED: "AdditionalInfoRequired",
};
export const PROPOSAL_BUCKET = {
  REQUIREMENT: "Requirement",
  REJECT: "Reject",
  REFER_TO_COPS: "ReferToCOPS",
  REFER_TO_PPC: "ReferToPPC",
  REFER_TO_TELEMER: "ReferToTeleMER",
  REFER_TO_UW: "ReferToUW",
  ADDITIONAL_INFO_REQUIRED: "AdditionalInfoRequired",
  ADDITIONAL_TEST_REQUIRED: "AdditionalTestRequired",
  ACCEPT_WITH_EXCLUSION_AND_LOADING: "AcceptWithExclusionAndLoading",
  ACCEPT_WITH_LOADING: "AcceptWithLoading",
  ACCEPT_WITH_EXCLUSION: "AcceptWithExclusion",
  COUNTER_OFFER_INITIATED: "CounterOfferInitiated",
  ACCEPT: "Accept",
  KYC_PENDING: "KycPending",
  CUSTOMER_CONSENT_PENDING: "CustomerConsentPending",
  PAYMENT_PENDING: "PaymentPending",
  PAYMENT_SUCCESSFUL: "PaymentSuccessful",
  POLICY_ISSUED: "PolicyIssued",
  NSTP: "NSTP", // DUMMY bucket value only for FE usages
  CANCELLED: "Cancelled",
};
export const MALE = [
  "Father",
  "Father In Law",
  "Grand Father",
  "Husband",
  "Son",
  "Son 1",
  "Son 2",
  "Son 3",
  "Son 4",
  "Son 5",
  "Brother",
  "Grand Son",
];
export const FEMALE = [
  "Mother",
  "Mother In Law",
  "Grand Mother",
  "Wife",
  "Daughter",
  "Daughter 1",
  "Daughter 2",
  "Daughter 3",
  "Daughter 4",
  "Daughter 5",
  "Sister",
  "Grand Daughter",
];

export const ADULT_MEMBERS = [
  "Self",
  "Spouse",
  "Father",
  "Father In Law",
  "Mother",
  "Mother In Law",
  "Grand Father",
  "Grand Mother",
];
export const PARENT_ARRAY = [
  "Mother",
  "Father",
  "Father In Law",
  "Mother In Law",
];
export const GRANDPARENT_ARRAY = ["Grand Father", "Grand Mother"];

export const TYPE_REVIEWER = {
  agent: "Agent",
  customer: "Customer",
};

export const NON_EDITABLE_STATUS_LIST = [
  PROPOSAL_BUCKET.REJECT,
  // PROPOSAL_BUCKET.REFER_TO_COPS,
  // PROPOSAL_BUCKET.REFER_TO_TELEMER,
  // PROPOSAL_BUCKET.REFER_TO_UW,
  // PROPOSAL_BUCKET.ADDITIONAL_INFO_REQUIRED,
  // PROPOSAL_BUCKET.ADDITIONAL_TEST_REQUIRED,
  // PROPOSAL_BUCKET.COUNTER_OFFER_INITIATED,
  // PROPOSAL_BUCKET.ACCEPT_WITH_EXCLUSION,
  // PROPOSAL_BUCKET.ACCEPT_WITH_EXCLUSION_AND_LOADING,
  // PROPOSAL_BUCKET.ACCEPT_WITH_LOADING,
  PROPOSAL_BUCKET.POLICY_ISSUED,
  PROPOSAL_BUCKET.PAYMENT_SUCCESSFUL,
  PROPOSAL_BUCKET.ACCEPT,
];
export const EDITABLE_STATUS_LIST = [
  PROPOSAL_BUCKET.REQUIREMENT,
  PROPOSAL_BUCKET.KYC_PENDING,
  PROPOSAL_BUCKET.CUSTOMER_CONSENT_PENDING,
  PROPOSAL_BUCKET.PAYMENT_PENDING,
  PROPOSAL_BUCKET.REFER_TO_PPC,
];
export const QUESTIONS_MAP = {
  q2: "Q1",
  q3: "Q2",
  q4: "Q3",
  q5: "Q4",
  q6: "Q5",
  q7: "Q6",
  q8: "Q7",
  q9: "Q8",
  q10: "Q9",
  q11: "Q10",
};
export const QUESTION_MAP_PA = {
  q1: "Q1",
  q2: "Q2",
};

export const STATUS_MAP = {
  "KYC Pending": [PROPOSAL_BUCKET.KYC_PENDING],
  "Counter Offer Letter": [PROPOSAL_BUCKET.COUNTER_OFFER_INITIATED],
  "Payment Pending": [PROPOSAL_BUCKET.PAYMENT_PENDING],
  "Info Required": [PROPOSAL_BUCKET.ADDITIONAL_INFO_REQUIRED],
  Pending: [
    PROPOSAL_BUCKET.REQUIREMENT,
    PROPOSAL_BUCKET.REFER_TO_PPC,
    PROPOSAL_BUCKET.PAYMENT_PENDING,
    PROPOSAL_BUCKET.NSTP,
  ],
};
export const CUSTOMER_DIARY = {
  newCust: "New Customer",
  existCust: "Existing Customer",
};

export const POLICY_DOWNLOAD_TYPE = {
  PROPOSAL_ACCEPT: "PROPOSAL_ACCEPT",
  POLICY_DOCUMENT: "POLICY_DOCUMENT",
  "80D": "80D",
  HEALTH_CARD: "HEALTH_CARD",
  PROPOSAL_REJECT: "PROPOSAL_REJECT",
  ADDITIONAL_INFO: "ADDITIONAL_INFO",
  PAY_IN_SLIP: "PAY_IN_SLIP",
  COL: "COL",
};
export const DOCUMENT_DOWNLOAD = ["80D", "HEALTH_CARD", "POLICY_DOCUMENT"];
export const PROPOSAL_STATUS_MESSAGE = {
  ReferToCOPS: "Your proposal will be sent for Document Verification.",
  ReferToCOPSPrePayment:
    "Your proposal will be sent for Document Verification post payment.",
  ReferToCOPSEndorsement:
    "Your endorsement request will be sent for Document Verification.",
  ReferToCOPSPrePaymentEndorsement:
    "Your endorsement request will be sent for Document Verification post payment.",

  ReferToPPC: "Our partner will reach out to you for a Pre Policy Checkup.",
  ReferToPPCPrePayment:
    "Our partner will reach out to you for a Pre Policy Checkup post payment.",

  ReferToTeleMER:
    "Our partner will reach out to you for a Tele – Medical Examination Report.",
  ReferToTeleMERPrePayment:
    "Our partner will reach out to you for a Tele – Medical Examination Report post payment.",

  ReferToUW: "Your proposal is being reviewed by an Underwriter.",
  ReferToUWPrePayment: "Your proposal will be reviewed by an UW post payment.",
  ReferToUWEndorsement:
    "Your endorsement request is being reviewed by an Underwriter.",
  ReferToUWPrePaymentEndorsement:
    "Your endorsement request will be reviewed by an UW post payment.",

  AdditionalInfoRequired:
    "Additional Information/Documents is required for processing of your proposal.",
  CounterOfferInitiated:
    "A Counter Offer has been proposed to you for your proposal.",
  Reject: "Your proposal has been Rejected.",
  PolicyIssued: "Your Policy has been issued.",
  Accept: "This is STP case. Policy will be issued post payment.",
  Review:
    "Your proposal is currently being reviewed. No further action required!",
  PolicyPayment: "Policy will be issued after payment.",
  AutoColInitiated: "Counter Offer has been initiated.",
  AutoColInitiatedPrePayment:
    "Counter Offer has been initiated. Policy will be issued post payment.",
  PolicyRenewed: "Your Policy has been renewed.",
  EndorsementCompleted: "Endorsement Completed on ",
  EndorsementRejected: "Endorsement request is rejected",
  EndorsementInitiated: "Endorsement request is initiated",
  EndorsementInProgress: "Endorsement request is in progress",
  Cancelled: "Your proposal has been Cancelled.",
  PolicyNstpPayment:
    "NSTP decision has been taken. Your policy will be issued post payment. Please proceed with the same.",
};

export const REJECTION_MASTER_CONTENT = {
  "EXCEPTION MASTER": "{{MEMBER_NAME}} has been Rejected (Reason - {{REASON}})",
  "DECLINE DISEASE MASTER":
    "{{MEMBER_NAME}} has been Rejected (Reason - {{REASON}}).",
  "LIFESTYLE MASTER":
    "{{MEMBER_NAME}} has been Rejected (Reason - {{REASON}} declaration not in permissible limits)",
  "MEDICAL MASTER": "{{MEMBER_NAME}} has been Rejected (Reason - {{REASON}}).",
  "SURGICAL MASTER": "{{MEMBER_NAME}} has been Rejected (Reason - {{REASON}}).",
  "BMI MASTER":
    "{{MEMBER_NAME}} has been Rejected (Reason - BMI not in permissible limit: {{REASON}}).",
  "TPA TRIGGER MASTER":
    "{{MEMBER_NAME}} has been Rejected (Reason - {{REASON}})",
  "ADD_ON RULES": "{{MEMBER_NAME}} has been Rejected (Reason - {{REASON}})",
};
export const AUTOCOL_MASTER_CONTENT = {
  "EXCEPTION MASTER": "Reason - {{REASON}}",
  "DECLINE DISEASE MASTER": "Reason - {{REASON}}",
  "LIFESTYLE MASTER":
    "Reason - {{REASON}} declaration not in permissible limits",
  "MEDICAL MASTER": "Reason - {{REASON}}.",
  "SURGICAL MASTER": "Reason - {{REASON}}.",
  "BMI MASTER": "Reason - BMI not in permissible limit: {{REASON}}",
  "TPA TRIGGER MASTER": "Reason - {{REASON}}",
  "ADD_ON RULES": "Reason - {{REASON}}",
};
export const AGE_BAND = {
  NOT_EQUAL: "notEqual",
  MORE: "more",
};
export const RETENTION_HEADER_MENU = [
  {
    id: "1",
    name: "Order Tracking",
    redirection: "order-tracking",
    isExpandable: false,
  },
];
export const HEADER_MENU = [
  {
    id: "1",
    name: "Home",
    redirection: "members",
    redirectionPA: "personal-accident/members",
    isExpandable: false,
  },
  // {
  //   id: "2",
  //   name: "Order Tracking",
  //   redirection: "order-tracking",
  //   redirectionPA: "order-tracking",
  //   isExpandable: false,
  // },
];

export const RELATIONSHIP_MASTER_MEMBERS = {
  Self: "Self",
  Spouse: "Spouse",
  Son: "Son",
  Daughter: "Daughter",
  Father: "Father",
  Mother: "Mother",
  "Father In Law": "Father-In Law",
  "Mother In Law": "Mother-In Law",
  "Grand Father": "Grand Father",
  "Grand Mother": "Grand Mother",
};
export const EXISTING_CUSTOMER =
  "Is the proposer or any of the persons proposed, already Insured under a health plan with Tata AIG  or any other insurer or is a proposal pending for Policy issuance?";
export const NATIONALITY_QUESTION =
  "Residence status of either Policyholder or any of the Insured Person(s) is Non-Resident Indian or Overseas Citizen of India or Foreign National?";
export const EXISTING_CUSTOMER_DOCUMENT_TYPE = [
  { id: 1, label: "Policy Number", value: "Policy Number" },
  { id: 2, label: "Proposal Number", value: "Proposal Number" },
];
export const tenureMarks = [
  { value: 1, label: "1 year" },
  { value: 2, label: "2 years" },
  { value: 3, label: "3 years" },
  { value: 4, label: "4 years" },
  { value: 5, label: "5 years" },
];
export const DOCUMENT_TYPE_LIST = ["Policy Number", "Proposal Number"];

export const ADDON_COVERS = {
  C001: "C001",
  C002: "C002",
  C003: "C003",
  C004: "C004",
  C005: "C005",
  C006: "C006",
  C007: "C007",
  C008: "C008",
  C009: "C009",
  C010: "C010",
  C011: "C011",
  C012: "C012",
  C013: "C013",
  C014: "C014",
  C019: "C019",
  C020: "C020",
  C021: "C021",
  C022: "C022",
};

export const ADDON_COVERS_NAME = {
  C007: "Room Category",
  C008: "Aggregate Deductible Discount",
  C009: "Voluntary Sublimits Discount",
};

export const ADVANCED_COVER_POP_UP_TEXT =
  "You have opted for Advanced cover which reduces waiting period for Pre Existing Diabetes Mellitus Type 2, Hypertension, Hyperlipidemia, & Asthma to 30 days from Policy commencement date with us. However, you have not declared any Pre-Existing Disease on the proposal form. If you still wish to continue with Advanced cover, kindly declare Pre Existing Diseases - Diabetes Mellitus Type 2, Hypertension, Hyperlipidemia (High Cholesterol) & Asthma, or you cannot opt for Advanced cover.";
export const PRODUCTS = {
  ELDERCARE: "Elder Care",
  SUPER_CHARGE: "Super Charge",
  MEDICARE_LITE: "MediCare LITE",
  MEDICARE_PLUS: "Medicare Plus",
  MEDICARE: "Medicare",
  MEDICARE_PREMIER: "Medicare Premier",
  MEDICARE_SELECT: "Medicare Select",
  ACCIDENT_SUPER_GUARD_PLUS: "Accident Super Guard Plus",
};

export const DOCUMENT_LISTS = {
  [PRODUCTS.ELDERCARE]: [
    {
      id: 1,
      docName: "Policy Wording",
      link: "https://www.tataaig.com/s3/Elder_Care_Policy_Wordings_9d18315430.pdf",
    },
    {
      id: 2,
      docName: "Brochure",
      link: "https://www.tataaig.com/s3/elder_care_brochure_8b110b6804.pdf",
    },
    {
      id: 3,
      docName: "Customer Information Sheet",
      link: "https://www.tataaig.com/s3/Tata_AIG_Elder_Care_CIS_a1c17bf958.pdf",
    },
    {
      id: 4,
      docName: "Prospectus",
      link: "https://www.tataaig.com/s3/eldercare_prospectus_b5d025637c.pdf",
    },
  ],
  [PRODUCTS.SUPER_CHARGE]: [
    {
      id: 1,
      docName: "Policy Wording",
      link: "https://www.tataaig.com/s3/Health_Super_Charge_Policy_Wordings_eed27d4280.pdf",
    },
    {
      id: 2,
      docName: "Customer Information Sheet (Value Plan)",
      link: "https://www.tataaig.com/s3/health_supercharge_value_plan_cis_ec515c4464.pdf",
    },
    {
      id: 3,
      docName: "Customer Information Sheet (Geo Plan)",
      link: "https://www.tataaig.com/s3/health_supercharge_geo_plan_cis_c853045b33.pdf",
    },
    {
      id: 4,
      docName: "Prospectus",
      link: "https://www.tataaig.com/s3/tata_aig_supercharge_prospectus_86607613da.pdf",
    },
    {
      id: 5,
      docName: "Rate Chart",
      link: "https://www.tataaig.com/s3/tata_aig_supercharge_rate_chart_066edc58bc.pdf",
    },
  ],
  [PRODUCTS.MEDICARE_LITE]: [
    {
      id: 1,
      docName: "Policy Wording",
      link: "https://www.tataaig.com/s3/Medicare_LITE_Policy_Wordings_4fdf058f02.pdf",
    },
    {
      id: 2,
      docName: "Customer Information Sheet",
      link: "https://www.tataaig.com/s3/Medicare_LITE_CIS_aa38ff0767.pdf",
    },
    {
      id: 3,
      docName: "Prospectus",
      link: "https://www.tataaig.com/s3/tata_aig_medicare_lite_prospectus_7834c76322.pdf",
    },
  ],
  [PRODUCTS.MEDICARE_PLUS]: [
    {
      id: 1,
      docName: "Policy Wording",
      link: "https://www.tataaig.com/s3/Tata_AIG_Medi_Care_Plus_e8a0cf5358.pdf",
    },
    {
      id: 2,
      docName: "Brochure",
      link: "https://www.tataaig.com/s3/Medicare_Plus_bc171907df.pdf",
    },
    {
      id: 3,
      docName: "Customer Information Sheet",
      link: "https://www.tataaig.com/s3/Medi_Care_Plus_eef8916f2b.pdf",
    },
    {
      id: 4,
      docName: "Prospectus",
      link: "https://www.tataaig.com/s3/Medi_Care_Plus_Prospectus_cb8fdfbba9.pdf",
    },
  ],
};

export const LABEL_MAPPING = {
  branch: "Branch",
  solid: "SOL ID",
  partner_branch_location: "Partner Branch Location",
  partner_employee_code: "Partner Employee Code",
  partner_employee_name: "Partner Employee Name",
  tagic_employee_code: "Tagic Employee Code",
  partner_application_number: "Partner Application Number",
  loan_account_number: "Loan Account Number",
  customer_account_number: "Customer Account Number",
  partner_cust_id: "Partner Cust ID",
  branch_sol_id: "Branch SOL ID",
  additional_detail_1: "Lead Id",
  additional_detail_2: "Additional Detail 2",
  sp_certificate_no: "SP Certificate No",
  specified_person_name: "SP Name",
  sp_av_details: "SP/AV Details",
  specified_person_place: "Branch Location",
  crm_link: "CRM Link",
  approval: "Approval",
  sop: "SOP",
};
export const VARIANT_CODE = { V001: "V001" };

export const PRODUCT_NAME_MAPPING = {
  2833: "Elder Care",
  2846: "Super Charge",
  2847: "MediCare LITE",
  2896: "Medicare Plus",
  28554: "Medicare Premier",
  28559: "Medicare",
  28572: "Medicare Select",
  28580: "Medicare Reserve",
};
export const DEDUCTIBLE_PRODUCTS = [2896, 28580];

export const VALUE_MAPPING = {
  additionalDetail1: "additional_detail_1",
  additionalDetail2: "additional_detail_2",
  approval: "approval",
  branch: "branch",
  branchSolId: "branch_sol_id",
  crmLink: "crm_link",
  customerAccountNumber: "customer_account_number",
  employeeCode: "partner_employee_code",
  loanAccountNumber: "loan_account_number",
  partnerApplicationNumber: "partner_application_number",
  partnerBranchLocation: "partner_branch_location",
  partnerCustomerId: "partner_cust_id",
  partnerEmployeeCode: "partner_employee_code",
  spCode: "specified_person_code",
  spName: "specified_person_name",
  branchLocation: "specified_person_place",
  partnerEmployeeName: "partner_employee_name",
};

export const PRODUCT_CODE_MAPPING = {
  "Elder Care": 2833,
  "Super Charge": 2846,
  "MediCare LITE": 2847,
  "Medicare Plus": 2896,
  "Medicare Premier": 28554,
  Medicare: 28559,
  "Medicare Select": 28572,
  "Medicare Reserve": 28580,
};
export const PRODUCT_NAME_MAPPING_PA = {
  42527: "Accident Super Guard Plus",
};
export const PRODUCT_CODE_MAPPING_PA = {
  "Accident Super Guard Plus": 42527,
};
export const VARIANT_NAME = {
  ELITE: "Elite",
  VALUE: "Smart",
};

export const DOCUMENT_TYPE = {
  NATIONALITY: "Nationality",
  MEDICAL_DOCUMENT: "Medical Document",
  COUNTER_OFFER_LETTER: "CounterOfferLetter Document",
  ADDITIONAL_INFO_REQUIRED: "Additional Info Required",
  TATA_AIG_CUSTOMER: "Tata Aig Customer",
  HEALTH_POLICY: "Health Policy",
  PORTABILITY_DOCUMENT: "Portability Document",
  REBOOK_POLICY: "Rebook Policy",
  INCOME_DOCUMENT: "Financial Document",
  SUPERUSER_RENEWAL: "Super User Approval Document",
  PROFESSIONAL_DOCUMENT: "Salaried Professional Document",
  GMC_DOCUMENT: "GMC Document",
  ADDITIONAL_DOCUMENT: "Additional Info Document",
};

export const CONVERTER_REFERENCE_TYPE = {
  "Policy Number": "policyNumber",
  "Proposal Number": "proposalNumber",
};

export const REVERSE_REFERENCE_TYPE = {
  policyNumber: "Policy Number",
  proposalNumber: "Proposal Number",
};

export const NETWORK_LIST_URL =
  "https://www.tataaig.com/locator/cashless-network-hospitals";

export const VARIANT_SUPER_CHARGE = {
  VALUE_PLAN: "Value Plan",
  GEO_PLAN: "Geo Plan",
};
export const MEMBER_WITH_NUMBER = [
  "Son 1",
  "Son 2",
  "Son 3",
  "Son 4",
  "Son 5",
  "Daughter 1",
  "Daughter 2",
  "Daughter 3",
  "Daughter 4",
  "Daughter 5",
];
export const CHILDREN = [
  "Son 1",
  "Son 2",
  "Son 3",
  "Son 4",
  "Son 5",
  "Daughter 1",
  "Daughter 2",
  "Daughter 3",
  "Daughter 4",
  "Daughter 5",
];
export const MEMBER_RELATIONSHIP_MAPPER = {
  "Son 1": "Son1",
  "Son 2": "Son2",
  "Son 3": "Son3",
  "Son 4": "Son4",
  "Son 5": "Son 5",
  "Daughter 1": "Daughter1",
  "Daughter 2": "Daughter2",
  "Daughter 3": "Daughter3",
  "Daughter 4": "Daughter4",
  "Daughter 5": "Daughter 5",
};

export const MEMBER_CHILDREN_MAPPER = {
  Self: "Self",
  Spouse: "Spouse",
  Father: "Father",
  Mother: "Mother",
  "Father In Law": "Father In Law",
  "Mother In Law": "Mother In Law",
  "Grand Father": "Grand Father",
  "Grand Mother": "Grand Mother",
  "Son 1": "Son",
  "Son 2": "Son",
  "Son 3": "Son",
  "Son 4": "Son",
  "Son 5": "Son 5",
  "Daughter 1": "Daughter",
  "Daughter 2": "Daughter",
  "Daughter 3": "Daughter",
  "Daughter 4": "Daughter",
  "Daughter 5": "Daughter 5",
};

export const CONSENT_KYC_MESSAGE =
  "KYC and Consent link has been shared with proposer";

export const BUSINESS_TYPE = {
  NEW: "New",
  PORT: "Port",
  RENEWAL: "Renewal",
  ENDORSEMENT: "Endorsement",
  NEW_BUSINESS: "New Business",
};

export const CONSENT_MESSAGE = "Consent link has been shared with proposer";

export const TENURE = [
  { id: 1, value: 1, label: "1 year" },
  { id: 2, value: 2, label: "2 years" },
  { id: 3, value: 3, label: "3 years" },
];

export const MESSAGE_TOOL_TIP_PORT =
  "Please toggle to off if you want us to consider this member as new business";

export const MESSAGE_TOOL_TIP_SAME_POLICY =
  "Use this toggle to indicate whether everyone is coming from same or different policies";

export const MESSAGE_TOOL_TIP_CLAIM_AMOUNT =
  "Use this toggle in case there is previous claim amount";

export const VALIDATED_STATE = {
  WITH_PORTING: {
    basicDetails: false,
    lifestyleDetails: false,
    medicalDetails: false,
    portingDetails: false,
    kycDetails: false,
    consentDetails: false,
    paymentDetails: false,
  },
  WITHOUT_PORTING: {
    basicDetails: false,
    lifestyleDetails: false,
    medicalDetails: false,
    bancaDetails: false,
    kycDetails: false,
    consentDetails: false,
    paymentDetails: false,
  },
  WITH_BANCA_AND_PORTING: {
    basicDetails: false,
    lifestyleDetails: false,
    medicalDetails: false,
    portingDetails: false,
    bancaDetails: false,
    kycDetails: false,
    consentDetails: false,
    paymentDetails: false,
  },
  WITH_OUT_BANCA_AND_PORTING: {
    basicDetails: false,
    lifestyleDetails: false,
    medicalDetails: false,
    kycDetails: false,
    consentDetails: false,
    paymentDetails: false,
  },
};

export const POLICY_EXPIRY_DATE_MESSAGE =
  "Policy expiry date should be within 10 days in past and in next 60 days";

export const BONUS_MESSAGE =
  "SI inclusive of Cumulative Bonus cannot be less than ₹50,000";

export const EXCLUSION_MESSAGE =
  "COL will be triggered for Permanent Exclusion cases";
export const PRODUCT_CODE = {
  2846: "2846",
  2833: "2833",
  2847: "2847",
  2896: "2896",
  2888: "2888",
  28554: "28554",
  28559: "28559",
  28572: "28572",
  28580: "28580",
};

export const PAGE_ROUTES = {
  MEMBERS: "/members",
  MEMBERS_DOB: "/members-dob",
  QUOTE: "/quote",
  QUOTE_PORT: "/port",
  PROPOSAL: "/proposal",
  PDP: "/pdp",
  PDP_BENEFITS: "/pdp-benefits",
  SUBMIT_DOCUMENTS: "/submit-documents",
  COUNTER_OFFER: "/counter-offer",
  NSTP: "/nstp",
  CONGRATULATION: "/congratulation",
  INFO: "/info",
  ORDER_TRACKING: "/order-tracking",
  TAGIC_TELEMER: "/tagic-telemer",
  REVIEW: "/review",
  REJECT: "/rejected",
  POLICY_HISTORY: "/policy-history",
  ENDORSMENT_ACTION: "/endorsement/actions",
  ENDORSMENT_ORDER_TRACKING: "/endorsement/order-tracking",
  CANCEL_REBOOK: "/cancel-rebook",
  KYC_FRAME: "/kyc-frame",
};

export const SEVERITY = {
  WARNING: "warning",
  SUCCESS: "success",
  ERROR: "error",
};

export const CLICK_AWAY_EVENT = "clickaway";

export const QUOTE_MESSAGES = {
  MAX_MEMBERS: "Maximum 7 members are allowed (4 Adults and 3 Children)",
  MAX_MEMBERS_PA: " Maximum 7 members are allowed (2 Adults and 5 Children)",
  ATLEAST_ONE: "Please select atleast one of the members",
  MAX_ADULTS: "Maximum 4 adults are allowed",
  MAX_CHILDREN: "Maximum 3 children are allowed",
  MAX_CHILDREN_PA: "Maximum 5 children are allowed",
  INVALID_PINCODE: "Invalid Pincode",
  INVALID_DEALERCODE: "Invalid Dealer Code",
  PARENTS_AGE_GREATER: "Parents age must be greater than Self/Spouse",
  CHILDREN_AGE: "Children age must be less than 25",
  GRAND_PARENTS_AGE_GREATER: "Grand Parents age must be greater than Parents",
  SHARE_QUOTE_SUCCESS_MESSAGE: "Quotes have been shared successfully!",
  CHILD_AGE_GREATER: "Children's age must be less than other members ",
  AGE_BAND: "Age of insured member's must be in range from 0 to 65 years",
  AGE_BAND_ELDER_CARE:
    "Age of insured member's must be in range from 65 to 85 years",
  AGE_BAND_SELECT:
    "Age of insured member's must be in range from 0 to 99 years",
  MAX_MEMBERS_ELDERCARE: "Maximum no of member in a Elder Care policy can be 2",
  CHILD_COUNT_ELDERCARE: "Children cannot be added in Elder Care policy",
  GRANDPARENT_COUNT:
    "Grand father and Grand Mother cannot be added in MedicarePlus policy",
  IN_LAW_COUNT:
    "Father In Law and Mother In Law cannot be added in MedicarePlus policy",
  SELF_REQUIRED_FOR_7TH_MEMBER:
    "You must add Self as a member before adding more than 6 members",
  RENEWAL_ENDORSEMENT_MAX_MEMBERS_FLOATER:
    "Maximum 5 members are allowed (2 Adults and 3 Children)",
  RENEWAL_ENDORSEMENT_MAX_MEMBERS_INDIVIDUAL:
    "Maximum 7 members are allowed (4 Adults and 3 Children)",
  REBOOK_ADULT_MEMBER: "Additional adult members cannot be added",
  REBOOK_RENEWAL_ADDITION:
    "Member Addition is not allowed in a renewal policy!",
  REBOOK_RENEWAL_TOGGLE:
    "Switch toggling is disabled during the cancel and rebook renewal flow.",
  NO_PRODUCTS_ELIGIBLE:
    "No products eligible for quote generation as per the selected criteria!",
  RESERVE_MAX_MEMBERS:
    "A maximum of 5 members can be covered for this product.",
  RESERVE_ALLOWED_RELATIONSHIP:
    "Only Self, Spouse, Son and Daughter can be covered for this product.",
};

export const BASIC_INFO_MESSAGES = {
  SCAN_DOCUMENTS: "Please wait while we scan your uploaded document(s)",
  SHARED_CONTRIBUTION_EQUAL_1OO:
    "Sum of Shared Contribution must be equal to 100",
  DATE_OF_BIRTH_AND_PINCODE_MISMATCH:
    "Date of Birth and pincode of the customer selected is not the same as used for quote creation. Please try again.",
  DATE_OF_BIRTH_MISMATCH:
    "Date of Birth of the customer selected is not the same as used for quote creation. Please try again.",
  PINCODE_MISMATCH:
    "Pincode of the customer selected is not the same as used for quote creation. Please try again.",
  TRY_AGAIN: "Some error occurred. Please try again.",
  ONE_MEMBER_PORT: "Atleast one member has to be port",
  SHARED_CONTRIBUTION_GREATER_0: "Shared contribution must be greater than 0%",
  SHARED_CONTRIBUTION_MAX_100: "Shared contribution can be maximum of 100%",
  ENDORSEMENT_DATA_EMPTY: "Please change data to continue with endorsement",
  DOCUMENT_UPLOAD_MANDATORY:
    "Document upload is required for Member Addition. Click 'Next' to proceed.",
  EMPLOYEE_DISCOUNT:
    "Since you have opted for employee discount in quote stage. Please click on Edit Details and proceed ",
};
export const MEDICAL_DETAIL_MESSAGES = {
  ATLEAST_ONE_MEMBER: "Select atleast 1 question for chosen members",
};
export const KYC_ARYA_SCRIPT =
  "https://arya-resources.s3.ap-south-1.amazonaws.com/tagic-kyc/arya_api.js";

export const DOC_DOWNLOAD_ERROR =
  "Unable to download the document please try after sometime.";
export const NSTP_MESSAGES = {
  ADVANCE_COVER_REJECTED_MEMBERS:
    "Advance Cover can not be opted for rejected member",
  UW_DECISION_SUCCESS: "Underwriter decisions submitted successfully!",
  COPS_DECISION_SUCCESS: "Cops decisions submitted successfully!",
  TELEMER_DECISION_SUCCESS: "TeleMER decisions submitted successfully!",
};
export const SINGLE_PRIVATE_ROOM = "Single Private Room";
export const ALL_ROOM_CATEGORIES_COVERED = "All Room Categories Covered";
export const SHARED_ACCOMMODATION_VARIANTS = [
  "Shared Accommodation",
  "Shared Accomodation",
];
export const DEDUCTIBLE_GREATER_THEN_SUM_INSURED =
  "Deductible can not be greater than sum insured!";
export const SUM_INSURED_LESS_THEN_DEDUCTIBLE =
  "Sum insured can not be less than deductible!";
export const DOCUMENT_FORMAT =
  "File format: pdf, jpeg, jpg, xlsx | Max size: 5mb";

export const DEFAULT_DEDUCTIBLE = 300000;
export const OLD_DEFAULT_DEDUCTIBLE = 200000;
export const SAME_DEDUCTIBLE_DEPENDENT_PARENT =
  "Deductible of all the dependent parents should be same";
export const SAME_DEDUCTIBLE_DEPENDENT_CHILD =
  "Deductible of all the dependent children should be same";

export const SAME_SI_DEPENDENT_PARENT =
  "Sum Insured of all the dependent parents should be same";
export const SAME_SI_DEPENDENT_CHILD =
  "Sum Insured of all the dependent children should be same";

export const DEPENDENT_CHILDREN = [
  "Son 1",
  "Son 2",
  "Son 3",
  "Son 4",
  "Son 5",
  "Daughter 1",
  "Daughter 2",
  "Daughter 3",
  "Daughter 4",
  "Daughter 5",
];
export const DEPENDENT_PARENTS = ["Father", "Mother"];
export const PEP_ERROR_MESSAGE =
  "As you have declared that you are a PEP/ close relative of PEP, you’ll be required to submit additional documents to complete the proposal.";

export const BENEFITS_ICONS = [
  "highEndDiagnostics",
  "consumablesBenefit",
  "homePhysiotherapy",
  "postOperative",
  "personalizedHealthCheckup",
  "homeNursing",
  "compassionateCare",
  "preventiveHealthCheckup",
  "annualPreventiveHealth",
  "cumulativeBonus",
  "medicalSecond",
  "compassionateTravel",
  "costSharing",
  "discountNetwork",
  "roomRent",
  "dietNutrition",
  "twelveTele",
  "wellnessServices",
  "restoreBenefits",
  "wellnessProgram",
  "prolongHospitalisation",
  "medicalDevicesCovers",
  "homeAssessment",
  "inPatient",
  "homeCare",
  "preHospital",
  "dayCare",
  "domiciliary",
  "organDonor",
  "ayushBenefit",
  "roadAmbulance",
  "personalizedHealth",
  "dayCare",
  "vaccinationCover",
  "5xSupercharge",
  "roomCategory",
  "healthCheckup",
  "bariatricSurgeryCover",
  "inPatientDental",
  "hearingAid",
  "dailySharedAccommodation",
  "dailyInsuredChild",
  "youngFamilyDiscount",
  "globalCover",
  "accidentalDeath",
  "copay",
  "maternity",
  "deliveryComplications",
  "firstYearVaccinations",
  "opdTreatment",
  "opdTreatmentDental",
];
export const PACKAGE_ICONS = [
  "sapphire",
  "diamond",
  "silver",
  "Advanced Cover",
  "All round",
  "Enhanced",
  "Global Suraksha",
  "Mental Wellbeing",
  "Protect",
  "Sakhi",
  "Accident Suraksha",
  "Cancer Benefit",
  "Horizon",
  "Pocket Saver",
  "Women Suraksha",
  "Restore Infinity Plus",
  "Inflation Protect",
  "Cumulative Bonus",
];
export const RESEND_COL_DOCUMENT =
  "The col document has been successfully reshared with the customer";
export const PEP_MESSAGE = {
  GREETING:
    " Dear Customer, Thank you for choosing TATA AIG General Insurance Co.Ltd. As per the Master Guidelines on AML/CFT issued by IRDAI, you’re requested to submit SOF document to establish the source of funds paid for the policy along with KYC documents. You are requested to sends the documents on",
  EMAIL: "CentralKYC@tataaig.com",
  CONTACT_DETAIL:
    " from your registered email id within next 3 days. You may contact us on our email & Toll-free no. for any queries.",
  SOP_LIST:
    " SOF documents list: - (Your Bank Statement for last 3 months / Latest ITR /Latest Form 16/Latest CA Certificate certifying your income)",
  DOCUMENT_LIST:
    "KYC documents list: -PAN & Masked AADHAR/DL/Passport/VOTER ID",
};
export const DEFAULT_IP_ADDRESS = "1.2.3.4";
export const WAITING_PERIOD = ["WP0001", "WP0002", "WP0003"];

export const OPTIONS = [
  {
    id: "1",
    label: "True",
    value: "true",
  },
  {
    id: "2",
    label: "False",
    value: "false",
  },
];

export const SEARCH_OPTION = [
  {
    id: 1,
    label: "Mobile Number",
    value: "mobileNo",
  },
  {
    id: 2,
    label: "Proposal Number",
    value: "proposalNo",
  },
  {
    id: 3,
    label: "Name",
    value: "name",
  },
  {
    id: 4,
    label: "Policy Number",
    value: "policyNo",
  },
];
export const PDP_FREEZE_ADDONS = ["C011", "C012", "C013"];
export const PDP_FREEZE_ADDONS_PORT = ["C001", "C002", "C005"];

export const ENDORSEMENT_ACTIONS = {
  EDIT_NOMINEE_DETAIL: "Nominee Details",
  EDIT_PROPOSER_MOBILE: "Proposer's Mobile No",
  EDIT_PROPOSER_EMAIL: "Proposer's E-mail",
  EDIT_PROPOSER_DETAIL_WITHOUT_PINCODE: "Proposer's Details",
  EDIT_INSURED_DETAILS: "Insured Name/Gender/Salutation/Marital Status",
  EDIT_PORTABILITY_DETAILS: "Portability Details",
  EDIT_PROPOSER_DOB: "Proposer's DOB",
  EDIT_INSURED_DOB: "Insured DOB",
  EDIT_MEDICAL_DECLARATION: "Medical Declarations",
  EDIT_LIFESTYLE_DECLARATION: "Lifestyle Declarations",
  ADD_MEMBER: "Addition of Members",
  DELETE_MEMBER: "Deletion of Members",
  CUMULATIVE_BONUS: "Cumulative Bonus",
};

export const ENDORSEMENT_CATEGORY = {
  CAT01: "EDIT_NOMINEE_DETAIL",
  CAT02: "EDIT_PROPOSER_MOBILE",
  CAT03: "EDIT_PROPOSER_DETAIL_WITHOUT_PINCODE",
  CAT04: "EDIT_INSURED_DETAILS",
  CAT05: "EDIT_PORTABILITY_DETAILS",
  CAT06: "EDIT_PROPOSER_DOB",
  CAT07: "EDIT_INSURED_DOB",
  CAT08: "ADD_MEMBER",
  CAT09: "DELETE_MEMBER",
  CAT10: "EDIT_MEDICAL_DECLARATION",
  CAT11: "EDIT_LIFESTYLE_DECLARATION",
  CAT12: "EDIT_PROPOSER_EMAIL",
  CAT13: "CUMULATIVE_BONUS",
};

export const PROPOSAL_PAGE_NAME = {
  BASIC_INFO: "basicInfo",
  PROPOSER_DETAILS: "proposerDetails",
  MEMBER_DETAILS: "memberDetails",
  NOMINEE_DETAILS: "nomineeDetails",
  COMMUNICATION_DETAILS: "communicationDetails",
  LIFESTYLE_DETAILS: "lifeStyleDetails",
  MEDICAL_DETAILS: "medicalDetails",
  PORTABILITY_DETAILS: "portabilityDetails",
  BANCA_DETAILS: "bancaDetails",
};
export const STATUS_MESSAGES_POLICY_HISTORY = {
  PolicyIssued: "aigColor61",
  InProgress: "aigColor51",
  Initiated: "aigColor51",
  Rejected: "aigColor21",
  Reject: "aigColor21",
  Accept: "aigColor61",
  Cancelled: "aigColor21",
};

export const TABLE_HEADER_ENDORSEMENT = [
  {
    id: 1,
    name: "Field",
  },
  { id: 2, name: "Previous Data" },
  { id: 3, name: "Endorsed Data" },
];
export const TABLE_HEADER_RENEWAL = [
  {
    id: 1,
    name: "Field",
  },
  { id: 2, name: "Previous Data" },
  { id: 3, name: "Renewal Data" },
];

export const MEMBER_DELETION_MESSAGE = {
  DELETE_ALL_MEMBER: "Cannot delete all the members of a policy",
  NO_MEMBER_SELECTED: "Please select atleast one member to continue",
};

export const ENDORSEMENT_STATUS = {
  INITIATED: "Initiated",
  IN_PROGRESS: "InProgress",
  ACCEPT: "Accept",
  REJECT: "Reject",
};

export const MEMBER_ADD_DELETION = {
  ADD: "add",
  DELETE: "delete",
};

export const ENDORSEMENT_DOCUMENTS = [
  "NIL_ENDORSEMENT",
  "MID_TERM_MEMBER_ADDITION",
  "MID_TERM_DELETION",
  "NON_NIL_ENDORSEMENT",
  "PORTABILITY_LETTER",
  "80D_ENDORSEMENT",
];

export const ENDORSEMENT_DOCUMENTS_NAME = {
  ENDORSEMENT_LETTER: "Endorsement Letter",
  NIL_ENDORSEMENT: "Endorsement Letter NIL",
  NON_NIL_ENDORSEMENT: "Endorsement Letter NON NIL",
  MID_TERM_MEMBER_ADDITION: "Mid-Term Member Addition Letter",
  MID_TERM_DELETION: "Mid-Term Member Deletion Letter",
  PORTABILITY_LETTER: "Portability Letter",
  "80D_ENDORSEMENT": "Endorsement 80D",
};

export const STATUS_MAPPER = {
  InProgress: "In Progress",
  PolicyIssued: "Policy Issued",
};

export const REMOVE_PLP_PRODUCT = [];

export const PORT_FIELD_MAPPER = {
  startDate: "Start Date",
  endDate: "End Date",
  policyNo: "Policy Number",
  insurerName: "Previous Insurer",
  sumInsuredWithBonus: "Sum Insured With Bonus",
  isPolicyClaimed: "Is Policy Claimed",
  claims: "Claims",
};
export const PORT_EXPIRY_DATE_MESSAGE =
  "Previous policy expiry date should not be greater then current policy start date";

export const VALID_ENDORSEMENT_MESSAGE =
  "Endorsement is not valid for this product";
export const FILE_UPLOAD_ERROR = "Error in uploading file.";

export const SALUTATIONS = [
  "Mr",
  "Mrs",
  "Ms",
  "Lady",
  "Miss",
  "Sist",
  "Shri",
  "Mis",
  "Mst",
  "Mstr",
];
export const PLAN_A = [500000, 1000000, 1500000, 2000000, 2500000, 5000000];
export const PLAN_A_PLUS = [7500000, 10000000, 20000000, 30000000];
export const INHOUSE_VENDOR = "TAGIC";
export const CANCEL_REBOOK_OPTIONS = {
  NEW_POLICY: "newPolicy",
  REBOOK: "rebook",
};

export const QUESTION_MAPPER = {
  q2: "Q1",
  q3: "Q2",
  q4: "Q3",
  q5: "Q4",
  q6: "Q5",
  q7: "Q6",
  q8: "Q7",
  q9: "Q8",
  q10: "Q9",
  q11: "Q10",
  q12: "Q11",
};
export const MEMBER_DISPLAY_ORDER = [
  "selfDob",
  "spouseDob",
  "son1Dob",
  "son2Dob",
  "son3Dob",
  "son4Dob",
  "daughter1Dob",
  "daughter2Dob",
  "daughter3Dob",
  "daughter4Dob",
  "fatherDob",
  "motherDob",
  "fatherInLawDob",
  "motherInLawDob",
  "grandFatherDob",
  "grandMotherDob",
];
export const MAX_MEMBERS = 7;
export const INDIRECT_CHANNELS = ["Direct", "E-Business"];

export const PEP_STATUS = {
  ACCEPT: "Allow",
  REJECT: "Reject",
  REFER: "Refer",
};

export const MEMBER_FIELDS = [
  "title",
  "firstName",
  "lastName",
  "middleName",
  "heightFeet",
  "heightInches",
  "weight",
  "dob",
  "gender",
  "maritalStatus",
  "sumInsured",
  "deductible",
  "nationality",
  "nationalityDocument",
  "annualIncome",
  "panNo",
];

export const PACKAGE_CATEGORY = {
  CE: "Coverage Enhancer",
  PS: "Premium Saver",
};
export const CHANNEL_VALUE = {
  AGENCY: "Agency",
  DIRECT: "Direct",
  EBUSINESS: "E-Business",
  BANCA: "Banca",
};

export const AGENCY_LIEU_COMMISSION_PERCENTAGES = [5, 7.5, 10, 15];

export const DISCOUNT_MAPPER = {
  youngFamilyDiscount: "Young Family",
  cappedDiscount: "Additional",
  familyFloaterDiscount: "Family Floater",
  favourableExperienceDiscount: "Favourable Exp.",
  longTermDiscount: "Long Term",
  multiIndividualDiscount: "Multi Individual",
  noClaimDiscount: "No Claim",
  totalDiscount: "Total Discount",
  longTerm: "Tenure",
  family: "Family Floater",
  riskClass: "Risk class",
  occupation: "Occupation",
  employee: "Employee",
  online: "Online",
};

export const DISCOUNT_KEYS = [
  // "youngFamilyDiscount",
  "cappedDiscount",
  "familyFloaterDiscount",
  "favourableExperienceDiscount",
  "longTermDiscount",
  "multiIndividualDiscount",
  "noClaimDiscount",
  "familyFloater",
];
export const DISCOUNT_KEYS_PA = [
  "longTerm",
  "family",
  "online",
  "riskClass",
  "occupation",
  "employee",
];

export const ADDITIONAL_DISCOUNT_KEYS = [
  // "professional",
  "employee",
  // "lieuOfCommission",
  // "loyalty",
];

export const ADDITIONAL_DISCOUNT_MAPPER = {
  professional: "Professional",
  employee: "Employee",
  lieuOfCommission: "Lieu of Commission",
  loyalty: "Loyalty",
};

export const TWIN_SHARING = "Twin Sharing";
export const MULTI_SHARING = "Multi Sharing";
export const ANY_ROOM = "Any Room";
export const OTM_FAILURE_STATUS = ["Execution Failed", "Payment Failed"];

export const FILE_DELETE_ERROR = "Error while deleting the file!";

export const NATIONALITY_MAPPER = {
  Indian: "INDIAN RESIDENT",
  Others: "NRI",
};

export const QUESTION_MAPPER_BAD_DATA = {
  0: "q2",
  1: "q3",
  2: "q4",
  3: "q5",
  4: "q6",
  5: "q7",
  6: "q8",
  7: "q9",
  8: "q10",
  9: "q11",
  10: "q12",
  11: "q13",
};

export const SUPER_CHARGE_BONUS_RIDER = "Supercharge Bonus Rider";

export const ENDORSEMENT_DOB_CHANGE_MESSAGE =
  "Decrease in Dob endorsement is not allowed on this policy please reach out to operations user to change details";
export const QUOTE_FILTER = {
  ALL_PRODUCTS: "All Products",
  INDEMNINTY: "Indemnity",
  DEDUCTIBLE: "Deductible",
};

export const OCCUPATION_TYPE = "Salaried";

export const PROFESSIONAL_DISCOUNT_ERROR_MESSAGE =
  "Please enter your official work email address.";
export const RELATIONSHIP_MASTER_MEMBERS_PA = {
  Self: "Self",
  Spouse: "Spouse",
  Son: "Son",
  Daughter: "Daughter",
};
export const RELATIONSHIP_MASTER_PA = {
  Self: "Self",
  Spouse: "Spouse",
  "Son 1": "Son 1",
  "Son 2": "Son 2",
  "Son 3": "Son 3",
  "Son 4": "Son 4",
  "Daughter 1": "Daughter 1",
  "Daughter 2": "Daughter 2",
  "Daughter 3": "Daughter 3",
  "Daughter 4": "Daughter 4",
};
export const PAGE_ROUTES_PA = {
  MEMBERS: "/personal-accident/members",
  MEMBERS_DOB: "/personal-accident/members-dob",
  PDP: "/personal-accident/pdp",
  PDP_BENEFITS: "/personal-accident/pdp-benefits",
  PROPOSAL: "/personal-accident/proposal",
  KYC_FRAME: "/personal-accident/kyc-frame",
  NSTP: "/personal-accident/nstp",
  SUBMIT_DOCUMENTS: "/submit-documents",
  COUNTER_OFFER: "/counter-offer",
  ENDORSEMENT_ACTION: "/personal-accident/endorsement/actions",
  POLICY_HISTORY: "/personal-accident/policy-history",
};

export const POLLING_LIMIT = 20;
export const DELAY = 5000;

export const TTD_COVERS = ["PA04", "PA05", "PA06"];
export const PA_PRECEDENCE = ["PA01", "PA02", "PA03"];
export const BASE_COVERS = ["PA01", "PA02", "PA03"];
export const RISK_SCORING_TYPE = {
  CLAIM: "claim",
  CHRONIC: "chronic",
};
export const T10_PORT_MESSAGE = {
  heading:
    "You are attempting to submit a portability case where the previous policy has already expire. In such cases,",
  mainHeading: "payment is allowed only via Receipt mode.",
  subHeading: "Please contact your agent.",
};

export const UPLOAD_DOCUMENTS_ERROR =
  "There was an error while uploading the documents. Please try again uploading documents or restart the endorsement process.";
export const RELATIONSHIP_NOMINEE = [
  "Self",
  "Spouse",
  "Husband",
  "Wife",
  "Son",
  "Daughter",
  "Mother",
  "Father",
  "Brother",
  "Sister",
  "Grand Daughter",
  "Grand Son",
];

export const DONT_HAVE_GMC = "Don't have GMC policy";

export const ALLOWED_RESERVE_RELATIONSHIP = [
  "Self",
  "Spouse",
  "Son",
  "Daughter",
];

export const YES_NO_LABELS = [
  { id: 1, label: "Yes", value: "Yes" },
  { id: 2, label: "No", value: "No" },
];
